(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const link = event.target.closest('[data-cc-card-destination]');
    if (!link) return;
    const card = link.closest('.product-card-wrapper');
    const variant = card?.querySelector('product-form input[name="id"]')?.value;
    if (variant) { const destination = new URL(link.href); destination.searchParams.set('variant', variant); link.href = destination.href; }
  }, true);

  document.addEventListener('change', function(event) {
    const input = event.target;
    const card = input.closest('.product-card-wrapper');
    if (!card) return;
    const id = input.dataset.variantId || (input.name === 'id' ? input.value : null);
    const map = card.querySelector('[data-cc-card-shipping-map]');
    const status = card.querySelector('[data-cc-card-shipping]');
    if (!id || !map || !status) return;
    try {
      const html = JSON.parse(map.textContent)[id];
      if (html) { status.innerHTML = html; status.dataset.currentVariantId = id; }
    } catch (error) {}
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    if (!window.ccsPremiumOfferBound) {
  window.ccsPremiumOfferBound = true;
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-ccs-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const region = button.closest('.ccs-cart-offers');
    const status = region.querySelector('.ccs-offer-status');
    button.disabled = true;
    const root = window.Shopify?.routes?.root || '/';
    try {
      const item = {id: Number(button.dataset.ccsAdd), quantity: Number(button.dataset.quantity)};
      if (button.dataset.packaging) item.properties = {_ccs_packaging: 'true'};
      const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[item],sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});
      const result = await response.json();
      if (!response.ok) throw new Error('add');
      const drawer = document.querySelector('cart-drawer');
      if (drawer?.renderContents) drawer.renderContents(result, true);
      else location.reload();
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'cart-items'});
    } catch(error) {
      button.disabled = false;
      status.textContent = status.dataset.error;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-thumbnail"] && !Shopify.designMode) return;
  try {
    (() => {
  document.addEventListener('click', event => {
    const player = event.target.closest('internal-video');
    const video = player?.querySelector('video[data-cc-demand-video]');
    if (!video || !event.target.closest('.internal-video__play,video')) return;
    const sources = video.querySelectorAll('source[data-cc-src]');
    if (!sources.length) return;
    sources.forEach(source => {
      source.src = source.dataset.ccSrc;
      source.removeAttribute('data-cc-src');
    });
    video.load();
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
